import React from 'react';

interface PaginacaoPessoasProps {
  pageMetadata: {
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
  };
  onPageChange: (page: number) => void;
}

const PaginacaoPessoas: React.FC<PaginacaoPessoasProps> = ({ pageMetadata, onPageChange }) => {
  const { totalPages, number, totalElements } = pageMetadata;
  
  if (totalPages <= 1) return null;

  return (
    <div className="pagination-container">
      <button 
        className="btn-pagination" 
        onClick={() => onPageChange(0)} 
        disabled={number === 0}
      >
        Primeira
      </button>
      <button 
        className="btn-pagination" 
        onClick={() => onPageChange(number - 1)} 
        disabled={number === 0}
      >
        Anterior
      </button>
      
      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
        const pageNum = Math.max(0, number - 2) + i;
        if (pageNum >= totalPages) return null;
        return (
          <button 
            key={pageNum} 
            className={`btn-pagination ${pageNum === number ? 'active' : ''}`} 
            onClick={() => onPageChange(pageNum)}
          >
            {pageNum + 1}
          </button>
        );
      })}
      
      <button 
        className="btn-pagination" 
        onClick={() => onPageChange(number + 1)} 
        disabled={number >= totalPages - 1}
      >
        Próxima
      </button>
      <button 
        className="btn-pagination" 
        onClick={() => onPageChange(totalPages - 1)} 
        disabled={number >= totalPages - 1}
      >
        Última
      </button>
      
      <div className="pagination-info">
        Página {number + 1} de {totalPages} ({totalElements} registros)
      </div>
    </div>
  );
};

export default PaginacaoPessoas;